export default __webpack_public_path__ + "b7a3703ca4202cf31f529d0b0f3e89be.png";